export default "__VITE_ASSET__898a724a__"